import React from 'react'
import FeedBackFormWrapper from './src/context/feed-back-form-wrapper'
import './index.css'

export const wrapPageElement = ({element, props}) => {
  return <FeedBackFormWrapper {...props}>{element}</FeedBackFormWrapper>
}
